// ** React Imports
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'

// ** Custom Components
import Avatar from '@src/@core/components/avatar'

// ** Utils
import { isUserLoggedIn } from '@src/utility/Utils'

// ** Store & Actions
import { useDispatch } from 'react-redux'
import { handleLogout } from '@src/redux/authentication'

// ** Third Party Components
import { User, Mail,Key, Sun, Moon, CheckSquare, MessageSquare, Settings, CreditCard, HelpCircle, Power } from 'react-feather'

// ** Reactstrap Imports
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap'

// ** Default Avatar Image
import defaultAvatar from '@src/assets/images/avatars/avatar-blank.png'
import { useSkin } from '@src/utility/hooks/useSkin'
import { useJwt } from "@src/utility/hooks/useJwt"
import {useTranslation} from "react-i18next"
import {settingAPIValidationErrors} from "@src/utility/Utils";
import {toast} from "react-toastify";

const UserDropdown = () => {
  // ** Store Vars
  const {i18n, t} = useTranslation()
  const dispatch = useDispatch()
  const { jwtService, setJwtService } = useJwt();

  // ** State
  const [userData, setUserData] = useState(null)

  const { skin, setSkin } = useSkin()

  //** ComponentDidMount
  useEffect(() => {
    if (isUserLoggedIn() !== null) {
      setUserData(JSON.parse(localStorage.getItem('userData')))
    }
  }, [])

  const resolveRole = () => {
    if (userData) {
      if (userData.is_superuser) {
        return "Superuser"
      } else {
        if (userData.groups.length === 1) {
          const role = userData.groups[0].name
          return role[0].toUpperCase() + role.substr(1, role.length)
        } else {
          let role = ''
          for (let i = 0; i < userData.groups.length; i++) {
            const single_role = userData.groups[i].name
            if (i === userData.groups.length - 1) role += `${single_role[0].toUpperCase() + single_role.substr(1, single_role.length)}`
            else role += `${single_role[0].toUpperCase() + single_role.substr(1, single_role.length)} & `
          }
          return role
        }
      }
    }
  }

  const resolveStatus = (userData) => {
    if (userData) {
      if (userData.is_active) {
        return "online"
      } else return "offline"
    } else return 'offline'

  }

  const ThemeToggler = () => {
    if (skin === 'dark') {
      return (
      <div onClick={() => setSkin('light')} style={{padding: '0.65rem 1.28rem'}}>
          <Sun size={14} className='ficon me-75'  />
          <span className='align-middle'>{t("Switch Theme")}</span>
        </div>
      )
    } else {
      return (
      <div onClick={() => setSkin('dark')} style={{padding: '0.65rem 1.28rem'}}>
        <Moon size={14} className='ficon me-75' />
        <span className='align-middle'>{t("Switch Theme")}</span>
      </div>
      )
    }
  }

  const LogoutItem = () => {
    return (
        <div onClick={ async() => {
          try {
            const response = await jwtService.logout()
            dispatch(handleLogout())
            toast.success(t("Successfully logged out"), {
              position: "bottom-right",
              autoClose: 2000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            })
          } catch (e) {
            let errors = settingAPIValidationErrors(e.response.data)
            if (Array.isArray(errors)) {
              errors = `${errors[0].name}: ${errors[0].msg}`
            }
            toast.warning(t(errors), {
              position: "bottom-right",
              autoClose: 2000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            })
          }

        }} style={{padding: '0.65rem 1.28rem'}}>
          <Power size={14} className='me-75'/>
          <span className='align-middle'>{t("Logout")}</span>
        </div>
    )
  }

  //** Vars
  const userAvatar = (userData && userData.avatar) || defaultAvatar

  return (
    <UncontrolledDropdown tag='li' className='dropdown-user nav-item'>
      <DropdownToggle href='/' tag='a' className='nav-link dropdown-user-link' onClick={e => e.preventDefault()}>
        <div className='user-nav d-sm-flex d-none'>
          <span className='user-name fw-bold'>{(userData && userData['email'])}</span>
          {userData ? (
              <span className='user-status'>{t(resolveRole(userData))}</span>
          ) : <span className='user-status'>{t("Not Classified")}</span>}
        </div>
        <Avatar img={userAvatar} imgHeight='40' imgWidth='40' status={`${resolveStatus(userData)}`} />
      </DropdownToggle>
      <DropdownMenu end>
        {/* <DropdownItem tag={Link} to='/pages/profile'>
          <User size={14} className='me-75' />
          <span className='align-middle'>Profile</span>
        </DropdownItem> */}
        {/* <DropdownItem tag={Link} to='/apps/email'>
          <Mail size={14} className='me-75' />
          <span className='align-middle'>Inbox</span>
        </DropdownItem>
        <DropdownItem tag={Link} to='/apps/todo'>
          <CheckSquare size={14} className='me-75' />
          <span className='align-middle'>Tasks</span>
        </DropdownItem>
        <DropdownItem tag={Link} to='/apps/chat'>
          <MessageSquare size={14} className='me-75' />
          <span className='align-middle'>Chats</span>
        </DropdownItem>
        <DropdownItem divider />
        <DropdownItem tag={Link} to='/pages/account-settings'>
          <Settings size={14} className='me-75' />
          <span className='align-middle'>Settings</span>
        </DropdownItem>
        <DropdownItem tag={Link} to='/pages/pricing'>
          <CreditCard size={14} className='me-75' />
          <span className='align-middle'>Pricing</span>
        </DropdownItem>
        <DropdownItem tag={Link} to='/pages/faq'>
          <HelpCircle size={14} className='me-75' />
          <span className='align-middle'>FAQ</span>
        </DropdownItem> */}
         <DropdownItem style={{padding: '0rem 0rem'}} className={"w-100"}>
           <ThemeToggler/>
        </DropdownItem>
         <DropdownItem tag={Link} to={'/change-password'}>
           <Key size={14} className={"me-75"}/>
           <span className={"align-middle"}>{t("Change Password")}</span>
        </DropdownItem>
        <DropdownItem style={{padding: '0rem 0rem'}}  className={"w-100"}>
          <LogoutItem/>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

export default UserDropdown
